import { Component } from "@angular/core";

@Component({
    selector: 'kpi-group-row',
    template: '<ng-content></ng-content>',
    host: { 'class': 'row row-cards' },
    standalone: false
})
export class KpiGroupRowComponent {

}